// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2X058","empty":"ModalGraph_empty__3FUw4"};